const rankings = [
  { rank: 1, title: '我独自升级', tag: '动作', heat: '🔥 9.8', change: 'up' },
  { rank: 2, title: '社内相亲', tag: '恋爱', heat: '🔥 9.6', change: 'up' },
  { rank: 3, title: '全知读者视角', tag: '奇幻', heat: '🔥 9.5', change: 'same' },
  { rank: 4, title: '恶役只有死亡结局', tag: '悬疑', heat: '🔥 9.3', change: 'up' },
  { rank: 5, title: '女神降临', tag: '校园', heat: '🔥 9.1', change: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          热度榜单
        </h2>
        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 ${
                i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-background-100 transition-colors duration-150 cursor-pointer`}
            >
              <span
                className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold whitespace-nowrap ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <span className="flex-1 text-sm md:text-base font-medium text-foreground-800">
                {item.title}
              </span>
              <span className="px-2 py-0.5 text-[10px] font-medium bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                {item.tag}
              </span>
              <span className="text-xs font-semibold text-accent-500 whitespace-nowrap">{item.heat}</span>
              <span className="w-5 text-center">
                <i
                  className={`text-xs ${
                    item.change === 'up'
                      ? 'ri-arrow-up-fill text-primary-500'
                      : item.change === 'down'
                      ? 'ri-arrow-down-fill text-foreground-400'
                      : 'ri-subtract-line text-foreground-400'
                  }`}
                ></i>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}